import { FlexBox } from '@vp/swan';
import { AnsweredTile } from '../AnsweredTile';
import type { ColorSelectorReply } from './parseReply';

/** Legacy's answered-tile geometry for color-selector: a shorter, uncropped swatch strip. */
const SWATCH_IMAGE_HEIGHT = 50;

/**
 * The settled, read-only answer for a color-selector turn: every color the customer picked,
 * shown inside their own message bubble as the shared `AnsweredTile` card — see that component
 * for why it isn't a SWAN `StandardTile`.
 *
 * Configures a shorter image than style-tiles' default (50px vs. 80px) with `fill` instead of
 * `cover`, matching legacy exactly: a color swatch is already a flat band of color, so cropping
 * it changes nothing but its height, while `cover` on a tall aspect ratio would zoom in and clip
 * the ends of the gradient.
 */
export function ColorSelectorMessageView({ data }: { data: ColorSelectorReply }) {
    // parseColorSelectorReply rejects empty arrays, but this guard keeps the view inert if
    // a caller bypasses the parser and hands us an impossible empty answer.
    if (data.length === 0) {
        return null;
    }

    return (
        <FlexBox gap={3} flexWrap="wrap">
            {data.map((color) => (
                <AnsweredTile
                    key={color.value}
                    imageUrl={color.imageUrl}
                    name={color.name}
                    imageHeight={SWATCH_IMAGE_HEIGHT}
                    imageObjectFit="fill"
                />
            ))}
        </FlexBox>
    );
}
